/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getEnrichedInstrumentLinks} from '../api'

 export const useQueryGetEnrichedInstrumentLinks = createReactQueryHook('getEnrichedInstrumentLinks', getEnrichedInstrumentLinks)
